import {  NgModule } from '@angular/core';
import { CommonModule, DatePipe} from '@angular/common';
import { LocalizationsComponent } from './localizations.component';
import { RouterModule, Routes } from '@angular/router';
import { BlockUIModule } from 'ng-block-ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BBSFControlsModule } from 'bbsf-controls';
import { ClipboardModule } from 'ngx-clipboard';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatMenuModule } from '@angular/material/menu';
import { InlineSVGModule } from 'ng-inline-svg';
import { EmptyDataModule } from '../empty-data/empty-data.module';

import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bbsf-utilities';
import { localizationsService } from '../shared/Services/localizationsService.service ';

const routes: Routes = [
  {
    path: '', component: LocalizationsComponent
  }
]


@NgModule({
  declarations: [LocalizationsComponent],
  imports: [
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    BBSFControlsModule,
    NgbModule,
    MatMenuModule,
    InlineSVGModule,
    EmptyDataModule
  ],
  providers:[
    EnvironmentService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    DatePipe,
    localizationsService
 
  ]
})
export class LocalizationsModule { 

}
